import TextareaAutosize from 'react-textarea-autosize';
import { StoreI18n, StoreSettings } from '../../../../Types/StoreTypes';
import { Button } from '../../../Utility/Button';

interface AdvancedSettingsProps {
    SettingsActions: any;
    i18n: StoreI18n['i18n'];
    Currentsettings: StoreSettings;
}

function AdvancedSettings({
    SettingsActions,
    i18n,
    Currentsettings,
}: AdvancedSettingsProps) {
    return (
        <div className="w-full flex gap-8 flex-col">
            <h4 className="block">{i18n.translate({ id: 'advancedSettings', sourceName: 'Settings' })}</h4>
            
            <div className="flex flex-col gap-2">
                <label>
                    {i18n.translate({ id: 'instanceSystemPrompt', sourceName: 'Settings' })}
                    <p className="text-sm text-gray-500 mb-2">
                        {i18n.translate({ id: 'instanceSystemPromptDescription', sourceName: 'Settings' })}
                    </p>
                    <TextareaAutosize
                        className="mt-3 bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100"
                        value={Currentsettings.instanceSystemPrompt}
                        onChange={(e) => SettingsActions.updateCurrentSettings({ instanceSystemPrompt: e.target.value })}
                        minRows={4}
                        maxRows={8}
                    />
                </label>
            </div>

            <div className="flex flex-col gap-2">
                <label>
                    {i18n.translate({ id: 'bestPracticeSystemPrompt', sourceName: 'Settings' })}
                    <p className="text-sm text-gray-500 mb-2">
                        {i18n.translate({ id: 'bestPracticeSystemPromptDescription', sourceName: 'Settings' })}
                    </p>
                    <TextareaAutosize
                        className="mt-3 bg-input-backgroundColor w-full p-3 border border-2 border-input-borderColor rounded-lg outline-none focus:border-primary transition-all duration-100"
                        value={Currentsettings.bestPracticeSystemPrompt}
                        onChange={(e) => SettingsActions.updateCurrentSettings({ bestPracticeSystemPrompt: e.target.value })}
                        minRows={4}
                        maxRows={8}
                    />
                </label>
            </div>

            <div className="mt-5 text-right">
                <Button onClick={SettingsActions.handleUpdateSettings}>
                    {i18n.translate({ id: 'save', sourceName: 'Main' })}
                </Button>
            </div>
        </div>
    );
}

export default AdvancedSettings; 